import { Button } from "../../shadCn/components/ui/button"

export function ButtonBasic({text, className, variant, size, onClick, disabled = false}) {
    return (
        <Button
            className={`text-[0.8rem] bold ${className}`}
            variant={variant}
            size={size}
            onClick={onClick}
            disabled={disabled}
        >
            {text}
        </Button>
    )
}